export enum DepartmentTableNamesEnum {
  'ContactPersonList' = 'ContactPersonList',
  'MainEngineList' = 'MainEngineList',
  'AuxEngineList' = 'AuxEngineList',
  'CargoHoldList' = 'CargoHoldList',
  'CargoGearList' = 'CargoGearList',
  'PauseLog' = 'PauseLog',
}
